<template>

  <br>
  <br>
  <br>
  <br>

  <div class="fixed-bottom m-auto bottom-0 max_width w-100 z-3">
    <div class="rounded-top-5 d-flex justify-content-between align-items-center px-4"
         style="height: 5.5rem;background-color: rgb(243,243,243)">

      <router-link :to="{name:'W_MyCustomer'}" :class="page === 'W_MyCustomer' ? 'active':''">
        <img v-if="page === 'W_MyCustomer'" src="../../assets/img/icon-Customer-A.png" class="icon-size-4" style="height: 2.5rem" alt="">
        <img v-else src="../../assets/img/icon-Customer-NA.svg" class="icon-size-4" style="height: 2.5rem" alt="">
      </router-link>


      <router-link :to="{name:'W_HomePage'}" :class="page === 'W_HomePage' ? 'active':''" class="">
        <img v-if="page === 'W_HomePage'" src="../../assets/img/icon-home-A.svg" class="icon-size-4" alt="">
        <img v-else src="../../assets/img/icon-home-NA.svg" class="icon-size-4" alt="">
      </router-link>


      <router-link :to="{name:'W_PreviewChats'}" :class="page === 'W_PreviewChats' ? 'active':''">
        <img v-if="page === 'W_PreviewChats'" src="../../assets/img/icon-chats-A.svg" class="icon-size-4" alt="">
        <img v-else src="../../assets/img/icon-chats-NA.svg" class="icon-size-4" alt="">
      </router-link>

    </div>
  </div>


</template>


<script>

import {useRoute} from "vue-router";

export default {

  name: 'BottomNavigationWorker',

  setup() {

    let page = useRoute().name


    return {
      page,
    }
  }
}
</script>


<style scoped>
.active {
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  margin-bottom: 5rem;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.24);
}
</style>